<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<main id="main" class="wrapper">
  <article class="inner">
    <div class="content">
      <h1 class="visually-hidden">Robert's Rules Bootcamp - Interactive Parliamentary Training</h1>
      <header><h2>Bootcamp</h2></header>
      <p>A complete interactive training. See <a class="class-link" (click)="scrollTo('class-dates')"><b>Class Dates </b></a>below.</p>
      <p>You speak. You do. You learn.</p>
      <p>No power points. No video.</p>
      <p>You will leave with new parliamentary skills.</p>

      <p><b>DURATION:</b> Class times are 3.5 hours.</p>


      <div class="table-wrapper">
        <table>
          <tbody>
            <tr>
              <td><b>PRICE:</b></td>
              <td><B>$55</B></td>
            </tr>
            <tr>
              <td><b>INCLUDES:</b></td>
              <td>Follow up Zoom for attendees upon request</td>
            </tr>
            <tr>
              <td><b>DURATION:</b></td>
              <td>Class times are 3-4 hours</td>
            </tr>
            <tr>
              <td><b>PRE-REGISTRATION:</b></td>
              <td><B>$45</B> with 5 Day Advanced Purchase Coupon</td>
            </tr>
            <tr>
              <td><b>GROUP DISCOUNTS:</b></td>
              <td><B>$35</B> each for groups over 30 available</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </article>
</main>

<section id="course-curriculum" class="wrapper">
  <article class="inner">
    <div class="content">

      <!-- Table -->
      <h3>Intro Class</h3>

      <div class="table-wrapper">
        <table>
          <thead>
            <tr><th>Topic </th>
            <th>Description</th>

          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Motion Practice</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Amendments </td>
          </tr>
          <tr>
            <td>3</td>
            <td>Committee Work</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Table -->
    <h3>Intermediate Class</h3>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Topic </th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Motion Practice</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Complex Motions</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Complex Amendments </td>
        </tr>
        <tr>
          <td>4</td>
          <td>Advanced Committee</td>

        </tr>
      </tbody>
    </table>
  </div>


  <!-- Table -->
  <h3>Advanced Topics Class</h3>

  <div class="table-wrapper">
    <table>
      <thead>
        <tr><th>Topic </th>
        <th>Description</th>

      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td>Point of Order</td>
      </tr>
      <tr>
        <td>2</td>
        <td>The Rules and Your Rights </td>
      </tr>
      <tr>
        <td>3</td>
        <td>How to Appeal Chair Decisions</td>

      </tr>
      <tr>
        <td>4</td>
        <td>How To Remove A Chair</td>
      </tr>
      <tr>
        <td>5</td>
        <td>Member Discipline Procedures</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="col-12">
  <P>Request a Bootcamp for your area:</P>
  <div class="requestbtn">
    <ul class="actions">
      <li><input type="submit" value="Request" routerLink="/contactus" class=""></li>
    </ul>
  </div>
</div>
<p>Note: Group pricing available UPON request.</p>

</div>
</article>
</section>


<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->

<!-- Main -->
<section id="class-dates" class="wrapper">
  <article class="inner">
    <div class="content">

      <header><h2>Class Dates</h2></header>

      @if (isLoading) {
        <div >
          <div class="spinner-container">
            <div class="spinner"></div>
          </div>
          <h5>Retrieving data...</h5>
        </div>
      }

      @if (!isLoading) {
        <div>
          @if (classes.length > 0) {
            <div>
              <div class="classlist-container">
                <table class="classes-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Purchase</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (class of classes; track class) {
                      <tr>
                        <td (click)="gotoClass(class.item_CODE)">{{ class.productTitle }}</td>
                        <td>{{ class.eventDate }}</td>
                        <td>
                          <button class="purchase-btn" (click)="gotoClass(class.item_CODE)">Register
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          @if (classes.length === 0 || noClassesMessage) {
            <div>
              <p>{{ noClassesMessage || 'No Bootcamps Scheduled.' }}</p>
              <p>Check Back Soon...</p>
            </div>
          }
        </div>
      }
    </div>
  </article>
</section>

<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->

<!-- Main -->
<section class="wrapper">
  <div class="inner">
    <div class="content">

      <!-- Elements -->
      <div class="row">

        <div class="col-12-medium">
          <h3>Testimonials</h3>
          <div class="box">
            <blockquote>"Not once was I bored. The exercises were like real life." -Rick</blockquote>
            <blockquote>"I never would have thought RR could be so interesting. Now I know how to accomplish something." -Alicia</blockquote>
          </div>
        </div>


      </div>
    </div>
  </div>
</section>

<!-- Main -->
<section class="wrapper">
  <div class="inner">
    <div class="content">

      <!-- Elements -->
      <div class="row">
        <div class="col-12-medium">

          <!-- Table -->
          <h3>Previous Class Dates</h3>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                <tr >
                  <td>Sept 2nd</td>
                  <td>Cass, MI</td>
                </tr>
                <tr >
                  <td>Aug 26th</td>
                  <td>Cass, MI<br> SOLD OUT</td>
                </tr>
                <tr >
                  <td>May 10th</td>
                  <td>Commerce Twnshp, MI</td>
                </tr>
                <tr >
                  <td>April 26th</td>
                  <td>Saginaw, MI</td>
                </tr>
                <tr >
                  <td>March 1st</td>
                  <td>Belding, MI<br> SOLD OUT</td>
                </tr>
                <tr >
                  <td>Feb 15th</td>
                  <td><b>MIGOP Bldg, Lansing</b></td>
                </tr>
                <tr >
                  <td>Jan 18th</td>
                  <td>Commerce Township <br> SOLD OUT</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
